<template>
  <div class="deletebe">
    <div class="deletebe_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">任职机构</div>
      <div class="determine" @click="toInformation">确定</div>
    </div>
    <div class="deletebe_bottm">
      <van-cell-group inset style="height: 48px; margin: 0px 0px">
        <van-field
          label="机构名称"
          v-model="item.unitName"
          placeholder="请输入机构名"
        >
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="item.job"
          placeholder="请输入"
          label="现任职位"
          maxlength="20"
          center
        >
          <template #button>
            <van-button size="small" style="border: none"
              >{{ item.job ? item.job.length : "0" }}/20</van-button
            >
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="fieldValue"
          is-link
          readonly
          clickable
          name="picker"
          :value="value"
          label="选择省市"
          placeholder="请选择"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请选择所在地区"
            :options="options"
            @close="showPicker = false"
            :field-names="fieldNames"
            @change="onChange"
            @finish="onFinish"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="item.address" placeholder="请输入" label="详细地址">
        </van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-field
          style="padding: 10px 0px"
          v-model="item.postCode"
          placeholder="请输入邮编"
          label="邮编"
        >
        </van-field>
      </van-cell-group>
      <van-cell-group inset>
        <van-checkbox class="check-box" v-model="item.defaultStatus"
          >默认</van-checkbox
        >
      </van-cell-group>
    </div>
    <div class="exit">
      <van-button class="bot" @click="show = true">删除</van-button>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text="取消"
        description="确定要删除职称？"
        close-on-click-action
        style="color: #ff3d3d"
        @select="onSelect"
      />
    </div>
  </div>
</template>
  
<script>
export default {
  name: "deletebe",
  data() {
    return {
      userInfo: "",
      itemIndexs: "",
      disabled: false,
      show: false,
      actions: [{ name: "删除" }],
      value: "",
      showPicker: false,
      cascaderValue: "",
      options: [],
      fieldValue: "",
      fieldNames: {
        text: "name",
        value: "code",
      },
      item: "",
    };
  },
  created() {
    this.proLists();
  },
  mounted() {
    this.item = JSON.parse(this.$route.query.item);
    console.log(this.item);
    // 省市回显
    if (this.item) {
      let provinceName = this.item.provinceName;
      let cityName = this.item.cityName;
      if (this.item.provinceName) {
        this.fieldValue = provinceName + "," + cityName;
      }
    }
    this.itemIndexs = JSON.parse(this.$route.query.indexs);
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      console.log(selectedOptions);
      this.item.provinceName = selectedOptions[0].name;
      this.item.cityName = selectedOptions[1].name;
      this.item.province = selectedOptions[0].code;
      this.item.city = selectedOptions[1].code;
      this.showPicker = false;
      this.fieldValue = selectedOptions.map((option) => option.name);
    },
    // 省联调
    async proLists() {
      let res = await this.$apis.userServe.proList();
      res.content.provinceList.map((province) => {
        province.children = [{ code: "", name: "" }];
      });
      this.options = res.content.provinceList;
    },
    onChange({ value, selectedOptions, tabIndex }) {
      this.cityLists(value);
    },
    // 市联调
    async cityLists(value) {
      console.log(this, this.options);
      var index = this.options.findIndex((item) => {
        return item.code == value;
      });

      let res = await this.$apis.userServe.cityList({
        provinceCode: Number(value),
      });
      this.$set(this.options[index], "children", res.content.cityList);
    },
    // 确认删除
    onSelect() {
      this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
      this.userInfo.scholarPresentUnit.splice(this.$route.query.indexs, 1);

      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));

      this.$router.push("information");
    },
    // 点击确定
    toInformation() {
      this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
      if (this.item.defaultStatus) {
        this.userInfo.scholarPresentUnit.forEach((item) => {
          item.defaultStatus = false;
        });
      }
      this.userInfo.scholarPresentUnit[this.itemIndexs] = this.item;
      sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
      this.$router.push("information");
    },
  },
};
</script>
  
<style lang="scss" scoped>
.deletebe {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .deletebe_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .deletebe_bottm {
    width: 94%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px;
  }

  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;

    .bot {
      width: 94%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3d3d;
      background: #ffffff;
      border-radius: 22px;
    }
  }
  .check-box {
    // margin: 10px 0;
    height: 44px;
  }
}
</style>